import * as actionTypes from './actionTypes';

export const requestLoadPersonalWorkouts = ({ params, userId }: { params?: any, userId: string }) => ({
  type: actionTypes.REQUEST_LOAD_PERSONAL_WORKOUTS,
  params,
  userId,
});
